import * as React from "react";
import IMyOrdersPage from "./IMyOrdersPage";
import OrdersList from "@market/components/OrdersList/OrdersList";
import OrderFilter from "@market/components/OrderFilter/OrderFilter";
import { connect } from "react-redux";
import { IInvestorData } from "@market/interfaces/IInvestorData";
import { IOrder } from "@market/interfaces/IOrder";
import Header from "@appComponents/Header/Header";
import SecondaryMarketService from "@services/SecondaryMarket.service";
import Loader from "@appComponents/Loader/Loader";
import { TReducers } from "@features/reducers";

import * as style from "./MyOrdersPageStyle.module.scss";
import * as general from "@appStyles/general.module.scss";

type State = {
  investorData: IInvestorData | null;
  orders: IOrder[];
  filterType: string;
  loader: boolean;
};

let ref: MyOrdersPage | null = null;

export class MyOrdersPage extends React.Component<IMyOrdersPage, State> {
  constructor(props: IMyOrdersPage) {
    super(props);

    this.state = {
      investorData: this.props.investorData,
      orders: [],
      filterType: "",
      loader: true,
    };

    ref = this;
  }

  componentDidMount() {
    SecondaryMarketService.getMyOrders().then((res) => {
      this.setState({
        orders: res.data.filter((order: IOrder) => {
          return order.status !== "cancelled";
        }),
        loader: false,
      });
    });
  }

  componentDidUpdate(prevProps: IMyOrdersPage) {
    if (prevProps.investorData === null && this.props.investorData !== null) {
      this.setState({
        investorData: this.props.investorData,
      });
    }
  }

  updateOrders = (orderId: number) => {
    this.setState({
      orders: this.state.orders.filter((order: IOrder) => {
        return order.id !== orderId;
      }),
    });
  };

  getFilterType = (filterType: string) => {
    this.setState({ filterType });
  };

  filterOrders = () => {
    let orders = this.state.orders;
    switch (this.state.filterType) {
      case "sell":
        orders = this.state.orders.filter(
          (order: IOrder) => order.type === "sell"
        );
        break;
      case "buy":
        orders = this.state.orders.filter(
          (order: IOrder) => order.type === "buy"
        );
        break;
      case "suspended":
        orders = this.state.orders.filter((order: IOrder) => {
          return order.spv_status === "suspended";
        });
        break;
    }
    return orders;
  };

  render() {
    return (
      <React.Fragment>
        <Header padding={"50 20"}>
          <h1 className={style.title}>My Orders</h1>
        </Header>
        <div className={general.appContainer}>
          {this.state.investorData !== null && (
            <div className={style.ordersContainer}>
              {this.state.loader ? (
                <Loader />
              ) : (
                <>
                  <OrderFilter filterOrders={this.getFilterType} />
                  <OrdersList
                    orders={this.filterOrders()}
                    investorId={this.state.investorData.id}
                    myOrdersList={true}
                    filter={this.state.filterType}
                  />
                </>
              )}
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (store: TReducers) => {
  return {
    investorData: store.secondaryMarketReducer.investorData,
  };
};

export default connect(mapStateToProps)(MyOrdersPage);

export const updateOrders = (orderId: number) => {
  ref ? ref.updateOrders(orderId) : null;
};
